var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{attrs:{"data":_vm.channelList,"props":_vm.props},on:{"node-click":_vm.sendDevicePush},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
return _c('span',{},[(node.isLeaf)?_c('span',[_c('i',{staticClass:"el-icon-video-camera",style:({color:node.disabled==1?'#67C23A':'#F56C6C'})})]):_c('span',[_c('i',{staticClass:"el-icon-folder"})]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(node.label)+"\n        ")])])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080b64da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/channelTree.vue
// module id = null
// module chunks = 